import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SessionService } from 'app/services/session.service';
import { Subscription } from 'rxjs/Subscription';
import { MaintenanceObjectService } from '../../../services/maintenance-object.service';
import { ItemUsage } from '../../../entities/ItemUsage';
import { MaintenanceObjectListConfig } from '../../../entities/enums/MaintenanceObjectListConfig';
import { MaintenanceObject } from 'app/entities/MaintenanceObject';

@Component({
  selector: 'app-maintenance-object-picker',
  templateUrl: './maintenance-object-picker.component.html',
  styleUrls: ['./maintenance-object-picker.component.css']
})
export class MaintenanceObjectPickerComponent implements OnInit, AfterViewInit, OnDestroy {

  private maintenanceObjectsSub: Subscription;
  private searchTimer: any;
  public searchFailed: boolean = false;
  public maintenanceObjects: any[];
  public oldMaintenanceObjects: MaintenanceObject[] = []
  public pickedMaintenanceObject: MaintenanceObject;
  public oldPMO: MaintenanceObject = new MaintenanceObject;
  public maintenanceSearch: string;
  public _showSearchBar: boolean = true;
  public _canHaveItems: boolean = false;
  public _canChangeSelection: boolean;
  _rootNo: string = '';
  public _itemColumnsToShow: any;
  public selectedConfiguration;
  _parentLimitNo: any = '';
  _Company_Reference: string = null;
  _maintenanceObjectConfiguration = MaintenanceObjectListConfig;
  _maximumQuantityLength = 9999;

  @Output()
  MaintenanceObjectSelectedEmitter = new EventEmitter();

  @Output()
  ListOfPendingMaintenanceObjectsChange = new EventEmitter<ItemUsage[]>();

  @Output()
  selectedConfigurationChange = new EventEmitter();

  @Output()
  isQuantityValidEmitter = new EventEmitter<boolean>();

  @Output()
  oldAndNewMOEmitter = new EventEmitter<{oldMO: MaintenanceObject, newMO: MaintenanceObject}>();

  @Input()
  ListOfPendingMaintenanceObjects: MaintenanceObject[];

  /**
   * Get value for selectedConfiguration from parent
   * Change the view to pickingList keeping configuration
   * (Used when going back from basket to view to edit choices)
   */
  @Input("selectedConfiguration")
  set SelectedConfiguration(_selectedConfiguration) {
    if (_selectedConfiguration === this._maintenanceObjectConfiguration.PickingList && this.selectedConfiguration === this._maintenanceObjectConfiguration.PendingList) {
      this.goBackToPreviousView();
    } else {
      this.selectedConfiguration = _selectedConfiguration;
    }
  }

  @Input()
  set ShowSearchBar(result: boolean) {
    this._showSearchBar = result;
  }

  @Input()
  set MaintenanceObjectPreSelected(result: any) {
    if (result != null && result != '') {
      this._rootNo = result;
    }
  }

  @Input()
  set CanHaveItems(result: boolean) {
    if (result != null) {
      this._canHaveItems = result;
    }
  }

  @Input()
  set TtemColumnsToShow(result: string) {
    if (result != null) {
      this._itemColumnsToShow = {};
      result.split('|').forEach(x => {
        this._itemColumnsToShow[x] = 1;
      });
    }
  }

  @Input()
  set CanChangeSelection(result: boolean) {
    this._canChangeSelection = result;
  }

  @Input()
  set ParentLimitNo(result: any) {
    if (!!result) {
      this._parentLimitNo = result;
    }
  }

  @Input()
  set Company_Reference(result: any) {
    if (!!result) {
      this._Company_Reference = result;
      this.GetMaintenanceObjects('');
    }
  }

  constructor(private maintenanceObjectService: MaintenanceObjectService, private sessionService: SessionService) {
    this.maintenanceSearch = '';
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    if (this.sessionService.getCompanyType() !== 'OTS') {
      this.GetMaintenanceObjects(this._rootNo);
    }
  }


  StringIsNullOrEmpty(string: string) {
    return !(typeof string != 'undefined' && string);
  }

  SetAndGetMaintenanceObjects(objectNo: any) {
    if (this._canChangeSelection) {
      this.maintenanceSearch = '';
      this.GetMaintenanceObjects(objectNo)

    }
  }

  GoBackOneObject() {
    if (this._canChangeSelection) {
      if (this._parentLimitNo != this.pickedMaintenanceObject.No) {
        this.GetMaintenanceObjects(this.pickedMaintenanceObject.Root_No)
      }
    }
  }

  GetMaintenanceObjects(root_no: string, filterByRootNo: boolean = true) {
    this.cancelPendingSearch();
    this.searchFailed = false;
    this.maintenanceObjectsSub = this.maintenanceObjectService.Get(root_no, this.maintenanceSearch, this._canHaveItems, filterByRootNo, this._Company_Reference).subscribe(x => {
      // If the table grows too much the description fields will lag. Consider pagination or less results
      let localChildObjects = x.Child_Objects.filter((_, i) => i < 100).map(x => {
        x.Is_In_Basket = false;
        x.Quantity = 1;
        return x;
      });
      if (!!this.ListOfPendingMaintenanceObjects && this.ListOfPendingMaintenanceObjects.length > 0) {
        this.maintenanceObjects = localChildObjects.map(x => {
          let foundItem = this.ListOfPendingMaintenanceObjects.find(o => o.No === x.No);
          if (foundItem) {
            return foundItem;
          } else {
            return x;
          }
        });
      } else {
        this.maintenanceObjects = localChildObjects;
      }
      // This is done to have a value to compare to
      this.oldMaintenanceObjects = this.deepCopyArray(this.maintenanceObjects)
      if (filterByRootNo == true) {
        let localRoot = x.Root_Object;
        if (localRoot) {
          localRoot.Is_In_Basket = false;
          localRoot.Quantity = 1;

          if (!!this.ListOfPendingMaintenanceObjects && this.ListOfPendingMaintenanceObjects.length > 0) {
            let foundObject = this.ListOfPendingMaintenanceObjects.find(o => o.No === x.Root_Object.No);
            if (foundObject) {
              this.pickedMaintenanceObject = foundObject;
            } else {
              this.pickedMaintenanceObject = localRoot;
            }
          } else {
            this.pickedMaintenanceObject = localRoot;
          }
        } else {
          this.pickedMaintenanceObject = localRoot;
        }
        this.MaintenanceObjectSelectedEmitter.emit(this.pickedMaintenanceObject);
        // This is done to have a value to compare to
        Object.assign(this.oldPMO, this.pickedMaintenanceObject)
      } else {
        this.pickedMaintenanceObject = null;
      }
    }, () => {
      this.maintenanceObjects = [];
      this.searchFailed = true;
    });
  }

  maintenanceSearchChanged(value: string) {
    this.maintenanceSearch = value;
    // Cancel immediately so an earlier response cannot replace the new search.
    this.cancelPendingSearch();
    this.searchTimer = setTimeout(() => this.maintenanceSearchedFocus(), 350);
  }

  maintenanceSearchedFocus() {
    this.maintenanceSearch = (this.maintenanceSearch || '').trim();
    this.GetMaintenanceObjects('', this.StringIsNullOrEmpty(this.maintenanceSearch));
  }

  private cancelPendingSearch() {
    clearTimeout(this.searchTimer);
    if (this.maintenanceObjectsSub) {
      this.maintenanceObjectsSub.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.cancelPendingSearch();
  }

  reset() {
    this.maintenanceSearch = '';
    this.pickedMaintenanceObject = null;
    this.GetMaintenanceObjects('');
  }

  /**
   * Add usage item to the basket
   * Allows only items with valid (!NullOrEmpty) Item_No
   * Allows only items with valid selected quantity
   */
  addUsageItemToPendingList(item: MaintenanceObject) {
    if (item.Quantity > 0 && item.Inventory > 0 && item.Item_No && item.Quantity <= item.Inventory) {
      item.Is_In_Basket = true;
      this.ListOfPendingMaintenanceObjects.push(item);
      this.ListOfPendingMaintenanceObjectsChange.emit(this.ListOfPendingMaintenanceObjects);
    }
  }

  shouldShowAddButton(item: MaintenanceObject): boolean {
    return item.Quantity > 0 && item.Inventory > 0 && item.Item_No && item.Quantity <= item.Inventory;
  }

  /**
   * Add order item to the basket
   * Allows only items with valid (!NullOrEmpty) Item_No
   */
  addOrderItemToPendingList(item: MaintenanceObject) {
    if (item.Quantity > 0) {
      if (item.Quantity > this._maximumQuantityLength) {
        item.Quantity = this._maximumQuantityLength;
      }
      if (item.Item_No) {
        item.Is_In_Basket = true;
        this.ListOfPendingMaintenanceObjects.push(item);
        this.ListOfPendingMaintenanceObjectsChange.emit(this.ListOfPendingMaintenanceObjects);
      }
    }
  }

  /**
   * Remove item from the pendingList (Basket)
   * If all items are removed, it returns to the previous position in the pickingList
   */
  removeFromPendingList(item) {
    let index = this.ListOfPendingMaintenanceObjects.indexOf(item);
    if (index !== -1) {
      this.ListOfPendingMaintenanceObjects.splice(index, 1);
    }
    if (this.ListOfPendingMaintenanceObjects.length < 1) {
      this.goBackToPreviousView();
    }
  }

  /**
   * Returns from pendingList (Basket) to the previous position in the pickingList
   */
  goBackToPreviousView() {
    if (!this.pickedMaintenanceObject) {
      this.GetMaintenanceObjects('');
    } else {
      this.GetMaintenanceObjects(this.pickedMaintenanceObject.No);
    }
    this.selectedConfiguration = this._maintenanceObjectConfiguration.PickingList;
    this.selectedConfigurationChange.emit(this.selectedConfiguration);
  }

  /**
   * Validate if selected Quantity for the objects in the basket is correct
   * Emmit this value to disable/enable 'submit' button
   */
  checkIfQuantityChanged() {
    // If Item Usage is selected
    let isValid = true;
    if (this._itemColumnsToShow['Items_Used'] == 1) {
      isValid = !this.ListOfPendingMaintenanceObjects.some(x => x.Quantity === 0 || x.Quantity > x.Inventory);
    } else if (this._itemColumnsToShow['Items_Ordered'] == 1) {
      isValid = !this.ListOfPendingMaintenanceObjects.some(x => x.Quantity === 0 || x.Quantity > this._maximumQuantityLength);
    }
    this.isQuantityValidEmitter.emit(isValid);
  }
  
  deepCopyArray(array: MaintenanceObject[]) {
    return JSON.parse(JSON.stringify(array));
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/maintenance-object-picker/maintenance-object-picker.component.ts